const HIGH_SCORE_KEY = "swipe_daruma_highscore";

export class StorageService {
  static saveHighScore(score: number): void {
    try {
      localStorage.setItem(HIGH_SCORE_KEY, String(score));
    } catch {
      // localStorage unavailable (e.g. private browsing)
    }
  }

  static loadHighScore(): number {
    try {
      const value = localStorage.getItem(HIGH_SCORE_KEY);
      return value ? parseInt(value, 10) || 0 : 0;
    } catch {
      return 0;
    }
  }

  static clearHighScore(): void {
    try {
      localStorage.removeItem(HIGH_SCORE_KEY);
    } catch {
      // ignored
    }
  }
}
